<template>
  <div>
    <div class="page-bg page">
      <div class="header-title">
        <h1>版权品市场</h1>
      </div>
      <div class="header-seach">
        <div class="seach-box">
          <input
            type="text"
            class="seach-input"
            placeholder="请输入搜索关键词"
            v-model="keywords"
          />
          <div class="seach-icon" @click="getGoodsList()"></div>
        </div>
      </div>
      <div class="goods-screen-main">
        <div class="goods-screen-option">
          <ul>
            <li
              v-for="(item, index) in sort"
              :key="index"
              :class="{ active: item.type === Math.abs(searchSort) }"
              @click="sortBtn(item.type)"
            >
              <span>{{ item.title }}</span>
            </li>
          </ul>
          <div class="tool-right">
            <div class="view-wrap">
              <span
                class="ui-icon"
                :class="goodsWrap === 1 ? 'ui-icon-one' : 'ui-icon-two'"
                @click="goodsWrapBtn()"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div ref="scroll-classify" class="classify-wrap">
          <div>
            <!-- <img :src="loadingImg" alt=""> -->
            <div class="goods-list">
              <div class="goods-list-wrap">
                <div
                  class="item"
                  :class="goodsWrap === 1 ? '' : 'goods-wrap-2'"
                  v-for="(item, index) in goodList"
                  :key="index"
                >
                  <router-link
                    :to="{ path: '/goods/details?id=' + item.slide_id }"
                  >
                    <div class="item-goods-box">
                      <div class="item-img">
                        <div
                          class="preview-img"
                          v-lazy:background-image="item.avatarimg"
                        ></div>

                        <div class="item-state" :class="'state-' + item.status">
                          <span>{{
                            Number(item.status) === 1
                              ? "热卖中"
                              : Number(item.status) === 2
                              ? "已售罄"
                              : "敬请期待"
                          }}</span>
                        </div>
                        <div class="item-collection">
                          <div class="icon"></div>
                          <div class="text">{{ item.collection_num }}</div>
                        </div>
                        <div
                          class="item-label"
                          v-if="Number(item.parent) === 0"
                        >
                          版
                        </div>
                        <div class="item-limit">
                          <div class="text">
                            限购:
                            <span>{{ item.num + " / " + item.all_num }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="item-info">
                        <div class="info-fl">
                          <div class="title">{{ item.title }}</div>
                          <div class="author">{{ item.author }}</div>
                        </div>
                        <div class="info-fr">
                          <div class="price">
                            ￥{{ item.price | formatMoney }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="com-empty" v-show="goodList.length < 1">
              <div class="empty">
                <div>
                  <p>没有要搜索到商品</p>
                  <img :src="require('@/assets/images/common/ic-empty.png')" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from "vue";
  import { mapActions, mapState } from "vuex";
  import IScroll from "../../../assets/js/libs/iscroll";

  import { Lazyload, Toast } from "vant";

  // Vue.use(Lazyload);

  // let loadingImg = require('@/assets/images/common/img-loading.png');

  Vue.use(Lazyload, {
    lazyComponent: true,
  });

  export default {
    name: "goods",
    data() {
      return {
        keywords: "",
        goodsWrap: 2,
        searchSort: 1,
        sort: [
          {
            type: 1,
            title: "时间排序",
          },
          {
            type: 2,
            title: "价格排序",
          },
          {
            type: 3,
            title: "收藏排序",
          },
        ],
      };
    },

    created() {
      let title = "";
      // console.log(this.$route.query.keywords);
      if (this.$route.query.keywords) {
        title = decodeURIComponent(this.$route.query.keywords);
        this.keywords = title;
      }
      
      this.getGoodsList();
    },
    methods: {
      ...mapActions({
        getGoods: "goods/getGoods",
        getGoodsSearch: "goods/getGoodsSearch",
      }),

      scrollPreventDefault(e) {
        e.preventDefault();
      },

      goodsWrapBtn() {
        let index = this.goodsWrap;
        if (index === 1) {
          this.goodsWrap = 2;
        } else {
          this.goodsWrap = 1;
        }

        // this.$nextTick(()=>{
        //     this.myScroll.scrollTo(0,0,0,IScroll.utils.ease.quadratic);
        //     this.myScroll.refresh();
        // })
      },

      getGoodsList() {
        let title = this.keywords;
        let searchSort = this.searchSort;
        let toastLoading = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "正在加载...",
        });
        this.getGoodsSearch({
          title: title,
          searchSort: searchSort,
          success: (res) => {
            // console.log(res);
            toastLoading.clear();
            if(title){
              if(res.status != 1){
                Toast(res.message);
              }
            }
            
          },
        });
      },

      sortBtn(type) {
        let sortType = type;
        this.searchSort = sortType;

        // console.log("之前：",type)
        // console.log("当前：",sortType)
        // console.log("正数：",Math.abs(sortType))
        // console.log(this.searchSort)

        this.getGoodsList();
      },
    },
    computed: {
      ...mapState({
        goodList: (state) => state.goods.goodList,
      }),
    },
    mounted() {
      // this.$refs['scroll-classify'].addEventListener("touchmove",this.scrollPreventDefault);
      // this.myScroll=new IScroll(this.$refs['scroll-classify'], {
      //     scrollX : false,
      //     scrollY : true,
      //     preventDefault : false
      // });
    },
    beforeDestroy() {
      // this.$refs['scroll-classify'].removeEventListener("touchmove",this.scrollPreventDefault);
    },
  };
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}
.wrap {
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.header-title {
  padding: 0.3rem 0;
  text-align: center;
  position: relative;

  h1 {
    position: relative;
    z-index: 9;
    font-size: 0.3rem;
    font-weight: bold;
    color: #333234;
    display: inline-block;
    line-height: 1.2;
    min-width: 3.56rem;
    padding: 0.1rem 0 0.08rem;
    &::after,
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
    }
    &::before {
      right: 0;
      bottom: 0;
      background: url("../../../assets/images/home/goods/tit-bg-1.png")
        no-repeat left top;
      background-size: auto 0.31rem;
    }
    &::after {
      top: 0;
      left: 0;
      background: url("../../../assets/images/home/goods/tit-bg-2.png")
        no-repeat right bottom;
      background-size: auto 0.22rem;
    }
  }
}
.header-seach {
  text-align: center;
  .seach-box {
    width: 4.48rem;
    height: 0.55rem;
    margin: 0 auto;
    position: relative;
    .seach-input {
      width: 4.48rem;
      height: 0.55rem;
      background: url("../../../assets/images/common/search-bg.png") no-repeat
        center;
      background-size: 100%;
      text-align: center;
      font-size: 0.26rem;
      color: #2c2827;
    }
    .seach-icon {
      position: absolute;
      right: 0.12rem;
      top: 0;
      width: 0.55rem;
      height: 0.55rem;
      background: url("../../../assets/images/common/search.png") no-repeat
        center;
      background-size: 0.29rem;
    }
  }
}
.goods-screen-main {
  padding: 0.36rem 0.3rem 0;

  .goods-screen-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ul {
      display: flex;
      align-items: center;
      li {
        margin-right: 0.28rem;
        font-size: 0.26rem;
        color: #939393;
        position: relative;
        line-height: 1.2;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.08rem;
          background: url("../../../assets/images/home/goods/screen-on.png")
            no-repeat center bottom;
          background-size: 100% 100%;
          opacity: 0;
        }
        &.active {
          color: #201e1e;
          &::after {
            opacity: 1;
          }
        }
      }
    }

    .tool-right {
      display: flex;
      align-items: center;
      .view-wrap {
        font-size: 0;
        .ui-icon {
          display: inline-block;
          width: 0.36rem;
          height: 0.36rem;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
        }
        .ui-icon-one {
          background-image: url("../../../assets/images/home/goods/icon-one.png");
        }
        .ui-icon-two {
          background-image: url("../../../assets/images/home/goods/icon-two.png");
        }
      }
    }
  }
}
.page-content {
  position: absolute;
  top: 2.6rem;
  bottom: 1.2rem;
  left: 0;
  width: 100%;
}
.classify-wrap {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling : touch;
}

@import "../../../assets/css/goods/goodList.scss";
</style>